export class SearchPublicationItems {
  id!: number;
  title!: string;
  date!: string;
  thumbnail!: string;
  translationKey!: string;
}
